import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, ModalController, LoadingController } from 'ionic-angular';
import { OrdersServices } from "./services";
import { Globals } from "../../globals";
import { KitchenHistoryPage } from "./kitchen-history/kitchen-history";
import { OrdersCoServices } from "../orders/services";
import { TakeawayServices } from '../takeaway/services';
import { TranslateService } from '@ngx-translate/core';
import { KitchenSectionsPage } from '../components/popups/kitchen-sections/kitchen-sections';
import { NativeStorage } from '@ionic-native/native-storage';
import { HttpClient } from '@angular/common/http';
import { KitchenDeleteOrdersPage } from './kitchen-delete-orders/kitchen-delete-orders';
import { PopupNewAppsPage } from '../components/popups/popup-new-apps/popup-new-apps';

/**
 * Generated class for the KitchenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen',
  templateUrl: 'kitchen.html',
})

export class KitchenPage {
  objectKeys = Object.keys;
  open_recipe: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    private takeawayServices: TakeawayServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private nativeStorage: NativeStorage,
    public loadingCtrl: LoadingController,
    public http: HttpClient) {
    //init
    this.globals.GAtrackView('Kitchen', 'Kitchen - View', this.globals.restaurant.email, 'View', 'View kitchen', 'Kitchen', '');
  }

  async ionViewWillEnter() {
    this.ordersServices.print_auto_on = false;
    this.ordersServices.presentLoading();
    this.ordersServices.getShowType();
    await this.getNativeStorage();
    this.takeawayServices.getTables(this.globals.restaurant_uid);
    this.ordersServices.getOrdersHidden(this.globals.restaurant_uid, this.globals.user_uid);
    await this.globals.delay(1000);
    await this.ordersServices.getOrdersShow(this.globals.restaurant_uid);
  }

  onBack() {
    this.globals.side_menu_active = 'dashboard';
    this.navCtrl.popToRoot();
  }

  show(index) {
    this.ordersServices.orders_array[index].show_kitchen = false;
    this.ordersServices.update(this.ordersServices.orders_array[index]);

  }

  openHistorial() {
    this.navCtrl.push(KitchenHistoryPage);
  }

  changeShowElements() {
    // if (this.globals.checkLimitsByLicense('kitchen','categories')) {//miramos los limites de la licencia
    //abre modal donde enseñaremos las categorias y que seleccione lo que quiere que se muestre(los seleccionades estaran en array)
    let profileModal = this.modalCtrl.create(KitchenSectionsPage,
      {
        //title: this.translate.instant('general-selecciona-secciones-mostrar'),
        title: this.translate.instant('general-que-mostrar-en-pantalla'),
      });
    profileModal.onDidDismiss(data => {
      this.openAllCols();
      this.ordersServices.saveNative()
    });
    profileModal.present();
    //  } else {
    //    this.navCtrl.push(AddonsTriggerVersionProPage);
    //  }
  }

  openAllCols() {
    //Mostramos todas la columnas
    var _cols = document.getElementsByClassName('kitchen-col') as HTMLCollectionOf<HTMLElement>;
    var _count = 0;
    while (_cols.length > _count) {
      if (_cols[_count] != null) {
        _cols[_count].style.display = 'block';
      }
      _count++;
    }
  }

  openOrders() {
    this.globals.side_menu_active = 'order';
    this.navCtrl.push(PopupNewAppsPage, { app: 'order' });
  }


  openHiddenOrderPage() {
    this.navCtrl.push(KitchenHistoryPage);
  }

  async getNativeStorage() {
    //Recuperamos los listados de tags y secciones para tener los activos
    this.nativeStorage.getItem('active_tags')
      .then(
        async value => {
          this.ordersCoServices.active_tags = await JSON.parse(value);
          await this.ordersCoServices.chargeElementsActiveTags();
        },
        async error => {
          await this.ordersCoServices.chargeElementsActiveTags();
        }
      );
    //creamos la estroctura de  name:TAG , active: true/false
    this.nativeStorage.getItem('active_sections')
      .then(
        async value => {
          if (value.length > 2) {
            this.ordersServices.select_show = await JSON.parse(value);
            //create array active_sections
            if (this.ordersServices.select_show[0].name != this.translate.instant('general-todos')) { //Si _active es undefined, lo ponemos en activo para que aparezca la order
              const confirm = this.alertCtrl.create({
                title: this.translate.instant('general-atencion'),
                message: this.translate.instant('kitchen-change-lang-alert'),
                buttons: [
                  {
                    text: this.translate.instant('general-aceptar'),
                    handler: () => {
                      this.ordersServices.change_language = true;
                      this.ordersServices.setSelectShow();
                      this.nativeStorage.setItem('active_sections', JSON.stringify([]));
                    }
                  },
                ]
              });
              confirm.present();
            }
            await this.ordersServices.setActiveSections();
          } else {
            await this.ordersServices.setSelectShow();
          }
        },
        error => { });
  }

  alertHideInactive() {
    const alert = this.alertCtrl.create({
      title: this.translate.instant('kitchen-ocultar-comandas'),
      message: this.translate.instant('kitchen-ocultar-comandas-desc'),
      buttons: [{
        text: this.translate.instant('general-cancelar'),
        role: 'cancel',
        handler: () => {

        }
      }, {
        text: this.translate.instant('general-aceptar'),
        handler: () => {
          this.hideInactive();
        }
      }]
    });
    alert.present();
  }

  async hideInactive() {
    const loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    for (let order of this.ordersServices.old_orders) {
      if (this.ordersServices.showOrHideOrder(order)) {
        //insert ocultar
        await this.ordersServices.insertOrderHidden(this.globals.restaurant_uid, order.UID, this.globals.user_uid);
      }
    }
    loadingPopup.dismiss();
  }

  alertDeleteInactive() {
    const alert = this.alertCtrl.create({
      title: this.translate.instant('kitchen-borrar-comandas'),
      message: this.translate.instant('kitchen-borrar-comandas-desc'),
      buttons: [{
        text: this.translate.instant('general-cancelar'),
        role: 'cancel',
        handler: () => {

        }
      }, {
        text: this.translate.instant('general-aceptar'),
        handler: () => {
          this.deleteInactive();
        }
      }]
    });
    alert.present();
  }

  async deleteInactive() {
    var oldOrdersToDelete = [];
    await this.ordersServices.getOrdersShow(this.globals.restaurant_uid);
    for (let order of this.ordersServices.old_orders) {
      if (this.ordersServices.showOrHideOrder(order)) {
        //await this.ordersServices.afs.collection('orders').doc(order.UID).delete();
        //
        oldOrdersToDelete.push(order.UID);
      }
    }
    //
    this.navCtrl.push(KitchenDeleteOrdersPage, {
      oldOrdersToDelete: oldOrdersToDelete
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/kitchen/kitchen.ts